import React from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
} from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { FileWithStatus } from "../types";
import StatusSuccessIconURL from "../../../assets/status-success-icon.svg";
import StatusErrorIconURL from "../../../assets/status-error-icon.svg";
import { ReactComponent as DeleteFileIcon } from "../../../assets/delete-file-icon.svg";

interface FileListItemProps {
  fileWithStatus: FileWithStatus;
  onRemove: (id: string) => void;
}

export const FileListItem = React.memo<FileListItemProps>(({ fileWithStatus, onRemove }) => {
  const { file, status, id } = fileWithStatus;
  const statusIcon =
    status === "valid" ? StatusSuccessIconURL : StatusErrorIconURL;
  const statusAlt = status === "valid" ? "Success" : "Error";
  let tooltipMessage = "";
  if (status === "password_protected") {
    tooltipMessage = "パスワードで保護されているため、処理できません。";
  } else if (status === "duplicate") {
    tooltipMessage = "重複しているため、処理できません。";
  } else if (status === "too_large") {
    tooltipMessage = `ファイルサイズが32MBを超えています (${(
      file.size /
      (1024 * 1024)
    ).toFixed(2)} MB)。`;
  }

  return (
    <ListItem
      key={id}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "0.5rem",
        paddingLeft: 6.5,
        paddingRight: 6.5, // アイコンの右側の余白を調整
      }}
    >
      <ListItemIcon sx={{ minWidth: "auto", marginRight: "8px" }}>
        <img
          src={statusIcon}
          style={{ width: "24px", height: "24px" }}
          alt={statusAlt}
        />
      </ListItemIcon>
      <Tooltip title={file.name} placement="top-start">
        <ListItemText
          primary={file.name}
          sx={{
            flexGrow: 1,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textDecoration: status !== "valid" ? "line-through" : "none",
          }}
        />
      </Tooltip>
      {status === "valid" ? (
        <IconButton edge="end" aria-label="delete" onClick={() => onRemove(id)}>
          <DeleteFileIcon style={{ width: "36px", height: "36px" }} />
        </IconButton>
      ) : (
        <Tooltip title={tooltipMessage} placement="left">
          <IconButton edge="end" aria-label="info" size="small">
            <InfoOutlinedIcon
              style={{ width: "24px", height: "24px", color: "#FF7292" }}
            />
          </IconButton>
        </Tooltip>
      )}
    </ListItem>
  );
});

FileListItem.displayName = "FileListItem";